// extracted by mini-css-extract-plugin
export default {"nav":"index_nav_gnhdR","logo":"index_logo_1LhH2","breadcrumbs":"index_breadcrumbs_G83jd"};